import { Card, CardContent } from "../../../ui/CustomCard/CustomCard";

export default function StatCard({
  icon,
  label,
  value,
  labelClassName,
  valueClassName,
  extra,
  className = "",
  contentClass = "",
}) {
  return (
    <Card
      className={`flex flex-col justify-center items-center text-white ${className}`}
    >
      <CardContent className={`p-3 sm:p-6 pt-0 ${contentClass}`}>
        <div className="flex flex-col justify-center items-center w-full p-2 sm:p-4">
          <div className="flex items-center space-x-2 text-gray-900 text-xs sm:text-sm mb-1 sm:mb-2">
            {icon}
            <span className={`${labelClassName}`}>{label}</span>
          </div>

          <div className="flex items-baseline space-x-2 mt-auto">
            <span
              className={`text-lg sm:text-2xl font-bold text-gray-900 leading-tight min-w-0 break-words ${valueClassName}`}
            >
              {value}
            </span>
            {extra && <div className="flex-shrink-0">{extra}</div>}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
